//dependencies
import { useAutoAnimate } from "@formkit/auto-animate/react";
import React from "react";

import { Avatar } from "@performyard/py-components";

//components
import AvatarGroup, { AvatarGroupProps } from "..";
import Container from "../../Container";
import Link from "../../Link";
import Typography from "../../Text";

interface ExpandableAvatarGroupProps extends Omit<AvatarGroupProps, "canShowModal"> {
	expanded: boolean;
}

/** @deprecated Use `AvatarGroup` from `@performyard/py-components` instead. */
const ExpandableAvatarGroup = ({
	employees = [],
	size = 20,
	maxLength,
	hasLinks = false,
	expanded,
}: ExpandableAvatarGroupProps) => {
	const [animationParent] = useAutoAnimate();
	return (
		<div ref={animationParent}>
			{!expanded && (
				<Container>
					<AvatarGroup employees={employees} size={size} maxLength={maxLength} hasLinks={hasLinks} />
				</Container>
			)}
			{(expanded ? employees : []).map((employee) => (
				<Link href={`/user/${employee?._id}/`} key={`${employee._id}`}>
					<Container marginBottom="4px" gap="8px" verticalAlignment="center">
						<div style={{ flexShrink: 0 }}>
							<Avatar size={24} id={employee?._id} name={employee?.name || "User"} />
						</div>
						<Typography size="paragraph-3" weight="semi-bold" overflowWrap="anywhere">
							{employee?.name}
						</Typography>
					</Container>
				</Link>
			))}
		</div>
	);
};

/** @deprecated Use `AvatarGroup` from `@performyard/py-components` instead. */
export default ExpandableAvatarGroup;
